/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

function Sponsors() {
  return (
    <>
      <div className="section section-pricing" id="sectionBuy">
        <Container>
          <Row className="our-clients">
            <Row className="mt-5" id="pricing">
              <Col className="mx-auto text-center mt-5" md="8">
                <h2 className="title">
                  <span className="text-primary">Our Sponsors</span>
                </h2>
              </Col>
              <Col className="mx-auto" lg="8" md="12">
                <p className="description mb-5 text-center">
                  We would like to take this opportunity to thank you for your
                  generous sponsorship that you have provided. We are happy to
                  report that your generous and selfless support will go a long
                  way into assisting us achieve more than we ever imagined. We
                  deeply appreciate your willingness and determination to come
                  in and sponsor our running for funds initiative. We hope and
                  wish that our association and relationship will be maintained
                  even in the future. Together we can always change the world to
                  become a better place. <br />
                  Thank you.
                </p>
              </Col>
            </Row>
            <Col lg="4" md="6" xs="6">
              <a href="https://humancausebrand.co.za/" target="_blank">
                <img
                  alt="..."
                  className="w-50"
                  src={require("assets/img/sponsors/human-cause.jpeg")}
                ></img>
              </a>
            </Col>
            <Col lg="4" md="6" xs="6">
              <a
                href="https://web.facebook.com/dylansolomonphysio"
                target="_blank"
              >
                <img
                  alt="..."
                  className="w-50"
                  src={require("assets/img/sponsors/DS physio.jpg")}
                ></img>
              </a>
            </Col>
            <Col lg="4" md="6" xs="6">
              <a
                href="https://web.facebook.com/styledelightscpt"
                target="_blank"
              >
                <img
                  alt="..."
                  className="w-50"
                  src={require("assets/img/sponsors/style delights.jpg")}
                ></img>
              </a>
            </Col>
          </Row>
          <Row style={{ marginTop: "1rem" }}>
            <Col lg="4" md="6" xs="6">
              <a href="https://web.facebook.com/StyleTravelSA" target="_blank">
                <img
                  alt="..."
                  className="w-50"
                  src={require("assets/img/sponsors/Style Travel.jpg")}
                ></img>
              </a>
            </Col>
            <Col lg="4" md="6" xs="6">
              <a href="https://www.skinscompression.com/za/" target="_blank">
                <img
                  alt="..."
                  className="w-50"
                  src={require("assets/img/sponsors/SKINS.png")}
                ></img>
              </a>
            </Col>
            <Col lg="4" md="6" xs="6">
              <a
                href="https://web.facebook.com/GSport-Apparel-109845144113252"
                target="_blank"
              >
                <img
                  alt="..."
                  className="w-50"
                  src={require("assets/img/sponsors/GSPORT LOGO.jpg")}
                ></img>
              </a>
            </Col>
          </Row>
          <Row style={{ marginTop: "1rem" }}>
            <Col lg="4" md="6" xs="6">
              <a href="https://xciter.co.za/" target="_blank">
                <img
                  alt="..."
                  className="w-50"
                  src={require("assets/img/sponsors/XCITER.png")}
                ></img>
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Sponsors;
